import { useState } from "react";
import { Loader2, StickyNote, Trash2 } from "lucide-react";
import { ConfirmButton, primary } from "./ConfirmButton";

export const AdminNotes = ({ notes, onAdd, onDelete, busy }) => {
  const [text, setText] = useState("");
  const add = async () => { if (await onAdd(text.trim())) setText(""); };
  return (
    <section className="rounded-2xl border bg-card p-5 shadow-soft" data-testid="admin-notes">
      <h2 className="flex items-center gap-2 text-base font-semibold text-foreground"><StickyNote className="h-4 w-4" />Private notes</h2>
      <p className="mt-0.5 text-xs text-muted-foreground">Only admins see these. Calls, special deals, anything worth remembering.</p>
      <textarea value={text} onChange={(e) => setText(e.target.value)} maxLength={2000} rows={3} placeholder="e.g. Called 6/12, agreed to 2 free months"
        className="mt-3 w-full resize-y rounded-xl border bg-background p-3 text-sm text-foreground focus:outline-none focus:ring-2 focus:ring-[color:var(--brand)]"
        data-testid="admin-note-input" />
      <div className="mt-2 flex items-center justify-between">
        <span className="text-xs text-muted-foreground">{text.length}/2000</span>
        <button type="button" className={primary} disabled={busy || !text.trim()} onClick={add} data-testid="admin-note-add-button">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />}Add note
        </button>
      </div>
      {notes.length > 0 && (
        <ul className="mt-4 divide-y" data-testid="admin-notes-list">
          {notes.map((n) => (
            <li key={n.id} className="flex items-start justify-between gap-3 py-3" data-testid={`admin-note-${n.id}`}>
              <div className="min-w-0">
                <p className="whitespace-pre-wrap break-words text-sm text-foreground">{n.text}</p>
                <p className="mt-1 text-xs text-muted-foreground">{n.admin_email} · {new Date(n.created_at).toLocaleString("en-US", { dateStyle: "medium", timeStyle: "short" })}</p>
              </div>
              <ConfirmButton testId={`admin-note-delete-${n.id}`} title="Delete this note?" description="This can't be undone. The deletion is recorded in the admin history."
                confirm="Delete" onConfirm={() => onDelete(n.id)} disabled={busy}
                className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-muted-foreground hover:bg-muted hover:text-red-600">
                <Trash2 className="h-4 w-4" />
              </ConfirmButton>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
};
